import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSettings } from '../context/SettingsContext';
import Loader from '../components/Loader';
import axios from 'axios';

const Contact = () => {

  const { settings, loading, error } = useSettings();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}inquiry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('Message sent successfully!');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        toast.error(data.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
    }
  };


  const [contactBanner, setContactBanner] = useState(null);

  const getContactBanner = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/ContactUsPageBanner`);
      setContactBanner(res.data.data[0]);
    } catch (err) {
      console.error('Error fetching Banner Content:', err);
    }
  }

  useEffect(() => {
    getContactBanner();
  }, []);

  if (contactBanner === null) {
    return <Loader />
  }

  return (
    <>
      <section className="inner-banner" style={{ backgroundImage: `url(${process.env.REACT_APP_SITE_IMAGES}${contactBanner.image_2})` }}>
        <div className="container-fluid web-padding">
          <div className="row">
            <div className="col-md-6" data-aos="flip-left" data-aos-duration={2000}>
              <div className="inner-banner-left">
                <h1>{contactBanner.title}</h1>
              </div>
            </div>
            <div className="col-md-6">
              <div className="inner-banner-right">
                <img src={`${process.env.REACT_APP_SITE_IMAGES}${contactBanner.image}`} alt="img" />
              </div>
            </div>
          </div>
        </div>
        <h2>Tyres</h2>
      </section>

      <section className="contact-main-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12" data-aos="flip-right" data-aos-duration={2000}>
              <div className="row">
                <div className="col-lg-12">
                  <h4>Get In Touch</h4>
                </div>
              </div>
              <div className="contact-pag-form">
                <div className="row ">

                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="name form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Name"
                            required
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          />
                          <i className="fas fa-user" />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <div className="name form-group">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Your Email"
                            required
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          />
                          <i className="fas fa-envelope" />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12">
                        <div className="details form-group">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Your Phone Number"
                            required
                            value={formData.phone}
                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                          />
                          <i className="fas fa-phone" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <div className="detailss">
                        <textarea
                          rows={8}
                          className="form-control"
                          placeholder="Message"
                          required
                          value={formData.message}
                          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                        />
                        <i className="fa-solid fa-message" />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <button className="theme-btn" type="submit">
                        Submit now
                        <span>
                          <img src="images/arrow-right.png" alt="icon" />
                        </span>
                      </button>
                    </div>
                  </form>

                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12" data-aos="flip-left" data-aos-duration={2000}>
              <div className="contact-side-bar">
                <div className="row">
                  <div className="col-lg-12">
                    <h4>info</h4>
                  </div>
                </div>
                <div className="contact-info">
                  <div className="col-md-3">
                    <div className="cicle-icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="contact_text">
                      <h2>Address</h2>
                      <p><a href="javascript:void(0);">{settings?.address}</a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="contact-info">
                  <div className="col-md-3">
                    <div className="cicle-icon">
                      <i className="fas fa-phone" />
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="contact_text">
                      <h2>Phone</h2>
                      <p><a href={`tel:${settings?.phone}`}>
                        {settings?.phone}
                      </a></p>
                    </div>
                  </div>
                </div>
                <div className="contact-info">
                  <div className="col-md-3">
                    <div className="cicle-icon">
                      <i className="fas fa-envelope" aria-hidden="true" />
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="contact_text">
                      <h2>Email At</h2>
                      <p><a href={`mailto:${settings?.email}`} className="email-text">{settings?.email}</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact